  <template>
    <div>
      <h1 class="pt-2 pb-2">User Details</h1>

      <b-card 
        class="p-0 overflow-hidden shadow"
        :class="isDark ? 'dark-card' : 'light-card'"
      >

        <!-- Loader -->
        <div v-if="dataloading" class="text-center p-5">
          <b-spinner label="Loading..."></b-spinner>
          <p class="mt-2">Loading user details...</p>
        </div>

        <div v-else>
          <!-- Cover Section -->
          <div class="cover-wrapper">
            <img v-if="myObj.cove" :src="myObj.cove" alt="cover" class="cover-img"/>
            <div v-else class="cover-placeholder">No Cover</div>
          </div>

          <!-- Profile Picture Overlap -->
          <div class="profile-pic-wrapper text-center">
            <img 
              v-if="myObj.pic" 
              :src="myObj.pic" 
              alt="profile pic" 
              class="profile-pic"
            />
            <div v-else class="profile-placeholder">No Pic</div>
          </div>

          <!-- Basic Info -->
          <div class="text-center mt-3">
            <h3 class="mb-1">{{ (myObj.title || '') + ' ' + (myObj.name || 'N/A') }}</h3>
            <p class="text-muted mb-1">{{ myObj.role || 'N/A' }}</p>
            <p class="bio-text">{{ myObj.bio || 'No bio available' }}</p>
          </div>

          <!-- Details Section -->
          <div class="details-section p-4">
            <b-row>
              <b-col md="6" class="mb-3"><i class="fa fa-calendar"></i> <strong>DOB:</strong><p>{{ myObj.dob || 'N/A' }}</p></b-col>
              <b-col md="6" class="mb-3"><i class="fa fa-birthday-cake"></i> <strong>Age:</strong><p>{{ myObj.age || 'N/A' }}</p></b-col>
              <b-col md="6" class="mb-3"><i class="fa fa-graduation-cap"></i> <strong>Qualification:</strong><p>{{ myObj.qualification || 'N/A' }}</p></b-col>
              <b-col md="6" class="mb-3"><i class="fa fa-arrows-alt-v"></i> <strong>Height:</strong><p>{{ myObj.height || 'N/A' }}</p></b-col>
              <b-col md="6" class="mb-3"><i class="fa fa-weight"></i> <strong>Weight:</strong><p>{{ myObj.weight || 'N/A' }}</p></b-col>
              <b-col md="6" class="mb-3"><i class="fa fa-envelope"></i> <strong>Email:</strong><p>{{ myObj.email || 'N/A' }}</p></b-col>
              <b-col md="6" class="mb-3"><i class="fa fa-phone"></i> <strong>Phone:</strong><p>{{ myObj.phone || 'N/A' }}</p></b-col>
              <b-col md="6" class="mb-3"><i class="fa fa-map-marker"></i> <strong>Address:</strong><p>{{ myObj.address || 'N/A' }}</p></b-col>
              <b-col md="6" class="mb-3"><i class="fa fa-user-tag"></i> <strong>Status:</strong><p>{{ myObj.status || 'N/A' }}</p></b-col>
            </b-row>
          </div>

          <!-- Geo Vault Rewards Section -->
          <div class="geo-vault-section mt-5 p-4">
            <h4 class="mb-3 text-center">🏅 Rewards</h4>

            <b-row>
              <b-col
                v-for="(reward, index) in rewards"
                :key="reward.id || index"
                md="4"
                sm="6"
                class="mb-4 text-center"
              >
                <b-card class="reward-card p-3 shadow-sm">
                  <img
                    :src="reward.icon"
                    alt="Reward Icon"
                    class="reward-icon mb-3"
                    v-if="reward.icon"
                  />
                  <div v-else class="reward-icon placeholder mb-3">No Image</div>
                  <h5 class="reward-title">{{ reward.title }}</h5>
                </b-card>
              </b-col>
            </b-row>

            <div v-if="rewards.length === 0" class="text-center text-muted mt-3">
              No rewards found.
            </div>
          </div>

         <!-- Achievements Section -->
<div class="geo-vault-section mt-5 p-4">
  <h4 class="mb-3 text-center">🏆 Achievements</h4>

  <div v-if="achievements && achievements.length" class="d-flex flex-wrap justify-content-center">
    <div
      v-for="achievement in achievements"
      :key="achievement.id"
      class="achievement-item m-2 p-2 border rounded shadow-sm text-center"
      style="width: 160px; cursor: pointer;"
      @click="openMedia(achievement)"
    >
      <h6 class="mb-1 text-truncate">{{ achievement.title }}</h6>

      <!-- Thumbnail -->
      <div class="achievement-thumb">
        <img
          v-if="isImage(achievement.mediaURL)"
          :src="achievement.mediaURL"
          class="img-fluid rounded"
          style="max-height: 100px; object-fit: cover;"
        />

        <video
          v-else-if="isVideo(achievement.mediaURL)"
          muted
          class="rounded"
          style="max-height: 100px; max-width: 100%; object-fit: cover;"
        >
          <source :src="achievement.mediaURL" type="video/mp4" />
        </video>

        <div
          v-else-if="isPDF(achievement.mediaURL)"
          class="d-flex align-items-center justify-content-center bg-light rounded"
          style="height: 100px;"
        >
          📄 <small class="ml-1">PDF</small>
        </div>

        <p v-else class="text-muted small mt-2 mb-0">No preview</p>
      </div>
    </div>
  </div>

  <p v-else class="text-center text-muted small">No achievements available</p>

  <!-- Popup Modal -->
  <div v-if="selectedMedia" class="media-modal" @click.self="closeMedia">
    <div class="media-modal-content p-3 bg-white rounded shadow-lg text-center">
      <button @click="closeMedia" class="close-btn btn btn-sm btn-danger float-right">✕</button>

      <h5 class="mb-2">{{ selectedMedia.title }}</h5>
      <p class="text-muted small">{{ selectedMedia.description }}</p>

      <div class="media-preview mt-3">
        <!-- Image -->
        <img
          v-if="isImage(selectedMedia.mediaURL)"
          :src="selectedMedia.mediaURL"
          class="img-fluid rounded"
          style="max-height: 70vh;"
        />

        <!-- Video -->
        <video
          v-else-if="isVideo(selectedMedia.mediaURL)"
          controls
          autoplay
          class="rounded"
          style="max-height: 70vh; max-width: 100%;"
        >
          <source :src="selectedMedia.mediaURL" type="video/mp4" />
        </video>

        <!-- PDF -->
        <iframe
          v-else-if="isPDF(selectedMedia.mediaURL)"
          :src="selectedMedia.mediaURL"
          style="width: 100%; height: 70vh; border: none;"
        ></iframe>

        <!-- Fallback -->
        <p v-else class="text-muted">No preview available</p>
      </div>
    </div>
  </div>
</div>



        </div>
      </b-card>

    
      </b-modal>
    </div>
  </template>

  <style scoped>
  .media-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.media-modal-content {
  max-width: 90%;
  max-height: 90%;
  overflow-y: auto;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}
  .clickable-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.25);
  }

  /* Image */
  .achievement-modal-img {
    max-width: 200px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  }

  /* Close button inside modal */
  .modal-close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    border-radius: 50%;
    padding: 4px 8px;
    line-height: 1;
  }

  /* Dark & Light modes */
  .dark-modal-body {
    background-color: #1c1f2e !important;
    color: #e5e7f2 !important;
  }
  .light-modal-body {
    background-color: #ffffff !important;
    color: #1b1f33 !important;
  }

  /* Content alignment */
  .modal-achievement-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .cover-wrapper {
    width: 100%;
    height: 220px;
    position: relative;
    background: var(--cover-bg);
  }
  .cover-img {
    width: 100%;
    height: 220px;
    object-fit: cover;
  }
  .mt-3,.my-3 {
    margin-top: 6rem !important;
  }
  .cover-placeholder {
    width: 100%;
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    background: var(--cover-placeholder-bg);
    color: var(--cover-placeholder-text);
  }

  .profile-pic-wrapper {
    position: absolute;
    top: 150px;   /* cover ki height ka ~70% */
    left: 50%;
    transform: translateX(-50%);
  }
  .profile-pic, .profile-placeholder {
    width: 140px;
    height: 140px;
    border-radius: 50%;
    object-fit: cover;
    border: 4px solid var(--profile-border);
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    background: #bbb;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bio-text {
    font-style: italic;
    color: var(--bio-text);
  }

  .details-section {
    background: var(--card-bg);
    border-top: 1px solid var(--card-border);
    border-radius: 0 0 8px 8px;
  }

  /* Geo Vault styles */
  .geo-vault-section {
    background: var(--card-bg);
    padding: 20px;
    border-radius: 12px;
    border: 1px solid var(--card-border);
    margin-bottom: 30px;
  }

  .reward-card {
    border-radius: 12px;
    background: var(--card-bg);
    transition: all 0.2s ease;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .reward-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }

  .reward-icon {
    width: 90px;
    height: 90px;
    object-fit: cover;
    border-radius: 50%;
    border: 3px solid var(--profile-border);
  }

  .reward-icon.placeholder {
    background: #ddd;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #666;
    width: 90px;
    height: 90px;
    border-radius: 50%;
    border: 3px solid var(--profile-border);
  }

  .reward-title {
    font-weight: 600;
    color: var(--bio-text);
  }

  /* clickable card */
  .clickable-card { cursor: pointer; }
  .hover-card { transition: transform .15s ease, box-shadow .15s ease; }
  .hover-card:hover { transform: translateY(-6px); box-shadow: 0 8px 22px rgba(0,0,0,0.14); }

  /* modal custom */
  .achievement-modal-content {
    max-width: 680px;
  }
  .modal-header-custom { border-bottom: 1px solid rgba(0,0,0,0.06); }

  /* small helpers */
  .small-muted { color: #6c757d; }

  /* 🎨 Light mode defaults */
  :root {
    --cover-bg: #f0f0f0;
    --cover-placeholder-bg: #444;
    --cover-placeholder-text: #fff;
    --profile-border: #fff;
    --bio-text: #888;
    --card-bg: #fff;
    --card-border: #eee;
  }

  /* 🌙 Dark mode override */
  body.dark-mode {
    --cover-bg: #2a2a2a;
    --cover-placeholder-bg: #222;
    --cover-placeholder-text: #ccc;
    --profile-border: #2a2a2a;
    --bio-text: #aaa;
    --card-bg: #1e1e2f;
    --card-border: #333;
  }
  </style>

  <script>
  /**
  * Integrated UserDetails component with Achievement Detail Modal
  * - Keeps existing logic intact (LoadData, LoadRewards)
  * - Adds: onAchievementClick, modal state, fallback fetch if description not present
  * - Uses Bootstrap-Vue b-modal (already available in imports above)
  */

  import {
    BFormFile,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BImg,
    BFormInvalidFeedback,
    BSpinner,
    BBadge,
    BFormTextarea,
  } from "bootstrap-vue";
  import Ripple from "vue-ripple-directive";
  import { ref } from "@vue/composition-api";
  import vSelect from "vue-select";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import Vue from "vue";
  import store from "@/store";
  import axios from "axios";
  import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
  import { required, minLength, between } from "vuelidate/lib/validators";
  import "viewerjs/dist/viewer.css";
  import VueViewer from "v-viewer";
  import Swal from "sweetalert2";

  Vue.use(VueViewer);

  export default {
    name: "UserDetails",
    components: {
      BFormTextarea,
      BButton,
      BImg,
      BRow,
      BCol,
      BCard,
      BMedia,
      BMediaAside,
      BLink,
      BSpinner,
    },
    directives: {
      Ripple,
    },
    created() {
      const id = window.location.pathname.split("/")[3];
      
      
      if (id) {
        this.LoadData(id);
        this.LoadRewards(id);
      }
    },
    data() {
      return {
        reason: "",
        vendor: {},
            selectedMedia: null,
        facilities: [],
        reviews: [],
        memberships: [],
        types: [],
        logoloading: false,
        plus: [],
        userVendorId: this.$store?.state?.userData?.userID || 0,
        moreloading: false,
        moreFiles: [],
        addOptions: "Add Cake",
        count: 0,
        costVisible: false,
        feedback: false,
        sizeOptions: [],
        imageUrl: "https://api.cloudinary.com/v1_1/dr9m7dwjw/upload",
        fileList: undefined,
        removecostId: 0,
        sizeId: 0,
        spin: "",
        files: undefined,
        cost: "",
        file: " ",
        name: " ",
        category: "",
        flvObj: {
          cakeFlavours: [],
          pId: 0,
        },
        originalSizearr: [],
        size: 0.0,
        loading: false,
        dataloading: false,
        selectedFiles: undefined,
        selectedFlavours: [],

        cakeFlavours: [],

        sizeObj: {
          size: "",
          cost: "",
        },
        categoryOptions: [],
        getproductId: 0,
        clickedItems: [],
        moreImages: [],
        productResponse: {},
        flavorOptions: [],
        // myObj will now contain both profile and userData fields
        myObj: {
          id: 0,
          name: "",
          businessType: 0,
          licenseNumber: "",
          cover: "",
          cove: "",
          pic: "",
          title: "",
          dob: "",
          age: "",
          qualification: "",
          height: "",
          weight: "",
          bio: "",
          images: "",
          timings: "",
          startAt: "",
          closesAt: "",
          days: "",
          description: "",
          price: 0,
          location: "",
          lat: "",
          lon: "",
          vendorID: 0,
          sequence: 0,
          status: "",
          reason: "",
          averageRating: 0,
          email: "",
          phone: "",
          address: "",
          role: "",
          facebook: "",
        },
        images: [],
        cakesizeList: [],
        sizes: {
          productId: 0,
          size: "",
          cost: "",
        },
        proImg: {
          pId: 0,
          images: [],
        },

        // Rewards
        rewards: [],
        achievements: [],
        isDark: false,

        // Modal state for achievement details
        showAchievementModal: false,
        modalLoading: false,
        selectedAchievement: null,
      };
    },

    methods: {
        openMedia(item) {
    this.selectedMedia = item;
  },
  closeMedia() {
    this.selectedMedia = null;
  },
  isImage(url) {
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
  },
  isVideo(url) {
    return /\.(mp4|mov|avi|mkv|webm)$/i.test(url);
  },
  isPDF(url) {
    return /\.pdf$/i.test(url);
  },
      // --- existing methods kept unchanged (but small bugfixes applied) ---
      isImage(url) {
  return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
},
isVideo(url) {
  return /\.(mp4|mov|avi|mkv|webm)$/i.test(url);
},
isPDF(url) {
  return /\.pdf$/i.test(url);
},

      Rejected() {
        this.myObj.reason = this.reason;
        var config = {
          method: "put",
          url: "https://waqta.appick.io/api/venues/Reject",
          headers: {
            Authorization: "Bearer " + (this.$store.state.userData.token || ""),
          },
          data: { id: this.myObj.id, reason: this.myObj.reason },
        };

        axios(config)
          .then((response) => {
            if (response.data.status === "success") {
              this.$bvModal.hide("modal-reject");
              if (
                this.myObj.status == "active" ||
                this.myObj.status == "Active"
              ) {
                Swal.fire("Success!", "Supended.", "success").then((res) => {
                  this.Back();
                });
              } else {
                Swal.fire("Success!", "Rejected.", "success").then((res) => {
                  this.Back();
                });
              }
            } else {
              this.$bvToast.toast("Something went wrong.", {
                title: "Error!",
                variant: "danger",
                toaster: "b-toaster-bottom-center",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      RejectVenue() {
        this.$bvModal.show("modal-reject");
      },
      Approve() {
        var config = {
          method: "put",
          url: "https://waqta.appick.io/api/venues/Approve?id=" + this.myObj.id,
          headers: {
            Authorization: "Bearer " + (this.$store.state.userData.token || ""),
          },
        };

        axios(config)
          .then((response) => {
            if (response.data.status === "success") {
              if (
                this.myObj.status == "Inactive" ||
                this.myObj.status == "inactive"
              ) {
                Swal.fire("Success!", "Activate.", "success").then((res) => {
                  this.Back();
                });
              } else {
                Swal.fire("Success!", "Approved.", "success").then((res) => {
                  this.Back();
                });
              }
            } else {
              this.$bvToast.toast("Something went wrong.", {
                title: "Error!",
                variant: "danger",
                toaster: "b-toaster-bottom-center",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      Back() {
        this.$router.replace({ name: "apps-banners" });
      },

      // Save method kept as-is (minor header fix)
      Save() {
        this.CheckName();
        this.Checktype();
        this.Checkprice();
        this.Checkemail();
        this.Checkphone();
        this.ChecklicenseNumber();
        this.Checktimings();
        this.Checklocation();
        this.Checkdays();
        this.Checkdescription();
        this.Checkfacebook();
        this.CheckImage();
        if (
          this.CheckName() == false ||
          this.Checktype() == false ||
          this.Checkprice() == false ||
          this.Checkemail() == false ||
          this.Checkphone() == false ||
          this.CheckImage() == false ||
          this.ChecklicenseNumber() == false ||
          this.Checktimings() == false ||
          this.Checklocation() == false ||
          this.Checkdays() == false ||
          this.Checkdescription() == false ||
          this.Checkfacebook() == false
        ) {
          return 0;
        } else {
          this.myObj.images = this.images.toString();
          var config = {
            method: "put",
            url: "https://waqta.appick.io/api/venues/" + this.myObj.id,
            headers: {
              Authorization: "Bearer " + (this.$store.state.userData.token || ""),
            },
            data: this.myObj,
          };

          axios(config)
            .then((response) => {
              if (response.data.status === "success") {
                console.log(response.data);

                this.$bvToast.toast("Venue updated.", {
                  title: "Success!",
                  variant: "success",
                  toaster: "b-toaster-bottom-center",
                });
                this.$router.replace({ name: "apps-banners" });
              } else {
                this.$bvToast.toast("Something went wrong.", {
                  title: "Error!",
                  variant: "danger",
                  toaster: "b-toaster-bottom-center",
                });
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      },

      // --- validation helpers (kept) ---
      CheckImage() {
        // template uses myObj.cove for cover image
        var elem = this.$refs["image"];
        if (!this.myObj.cove || this.myObj.cove === "") {
          if (elem) elem.state = false;
          return false;
        } else {
          if (elem) elem.state = true;
          return true;
        }
      },
      Checkphone() {
        var elem = this.$refs["phone"];
        if (this.myObj.phone == "" || this.myObj.phone == null) {
          if (elem) elem.state = false;
          return false;
        } else {
          if (elem) elem.state = true;
          return true;
        }
      },
      CheckName() {
        var elem = this.$refs["name"];
        if (this.myObj.name == "" || this.myObj.name.length < 3) {
          if (elem) elem.state = false;
          return false;
        } else {
          if (elem) elem.state = true;
          return true;
        }
      },
      Checktype() {
        var elem = this.$refs["type"];
        if (
          this.myObj.businessType == 0 ||
          this.myObj.businessType == undefined ||
          this.myObj.businessType == null
        ) {
          if (elem) elem.state = false;
          return false;
        } else {
          if (elem) elem.state = true;
          return true;
        }
      },
      Checkprice() {
        var elem = this.$refs["price"];
        const regex = /^\d+(,\d{1,2})?$/;
        if (parseInt(this.myObj.price) !== 0) {
          if (regex.test(this.myObj.price)) {
            this.myObj.price = parseInt(this.myObj.price);
            if (elem) elem.state = true;
            return true;
          } else {
            if (elem) elem.state = false;
            return false;
          }
        } else {
          this.myObj.price = "";
          if (elem) elem.state = false;
          return false;
        }
      },
      Checkemail() {
        var elem = this.$refs["email"];
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (
          re.test(String(this.myObj.email).toLowerCase()) &&
          this.myObj.email !== ""
        ) {
          if (elem) elem.state = true;
          return true;
        } else {
          if (elem) elem.state = false;
          return false;
        }
      },
      ChecklicenseNumber() {
        var elem = this.$refs["licenseNumber"];
        if (
          this.myObj.licenseNumber == "" ||
          this.myObj.licenseNumber.length < 3
        ) {
          if (elem) elem.state = false;
          return false;
        } else {
          if (elem) elem.state = true;
          return true;
        }
      },
      Checktimings() {
        var elem = this.$refs["timings"];
        if (this.myObj.timings == "") {
          if (elem) elem.state = false;
          return false;
        } else {
          if (elem) elem.state = true;
          return true;
        }
      },
      Checklocation() {
        var elem = this.$refs["location"];
        if (this.myObj.location == "") {
          if (elem) elem.state = false;
          return false;
        } else {
          if (elem) elem.state = true;
          return true;
        }
      },
      Checkdays() {
        var elem = this.$refs["days"];
        if (this.myObj.days == "") {
          if (elem) elem.state = false;
          return false;
        } else {
          if (elem) elem.state = true;
          return true;
        }
      },
      Checkdescription() {
        var elem = this.$refs["description"];
        if (this.myObj.description == "") {
          if (elem) elem.state = false;
          return false;
        } else {
          if (elem) elem.state = true;
          return true;
        }
      },
      Checkfacebook() {
        var elem = this.$refs["facebook"];
        if (this.myObj.facebook == "" || this.myObj.facebook == null) {
          if (elem) elem.state = false;
          return false;
        } else {
          if (elem) elem.state = true;
          return true;
        }
      },
      removeImg(index) {
        this.images.splice(index, 1);
        if (this.$refs.mfile) this.$refs.mfile.value = null;
      },
      deleteLogo() {
        this.myObj.cove = "";
        this.logoloading = false;
        if (this.$refs.fileProfile) this.$refs.fileProfile.value = null;
      },
      selectlogo() {
        this.fileProfile = this.$refs.fileProfile && this.$refs.fileProfile.files ? this.$refs.fileProfile.files[0] : null;
        var axiosReq = axios;
        if (this.fileProfile) {
          this.logoloading = true;
          let formData = new FormData();
          formData.append("file", this.fileProfile);
          formData.append("upload_preset", "geotalent");
          axiosReq
            .post("https://api.cloudinary.com/v1_1/dr9m7dwjw/upload", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((e) => {
              var fn1 = e.data.url;
              this.plus = fn1;
              this.myObj.cove = this.plus;
              this.logoloading = "loaded";
              this.CheckImage();
            })
            .catch((err) => {
              console.log(err);
              this.logoloading = false;
            });
        }
      },
      selectMoreFile() {
        if (!this.$refs.mfile || !this.$refs.mfile.files) return;
        if (this.$refs.mfile.files.length !== 0) {
          this.moreloading = true;
          let formData = new FormData();
          for (var i = 0; i < this.$refs.mfile.files.length; i++) {
            formData.append("file", this.$refs.mfile.files[i], "[PROXY]");
          }
          formData.append("upload_preset", "geotalent");

          var requestOptions = {
            method: "POST",
            body: formData,
            redirect: "follow",
          };

          // Using fetch to Cloudinary for multiple files may vary; keep as original logic but corrected
          fetch("https://api.cloudinary.com/v1_1/dr9m7dwjw/upload", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              // Cloudinary single upload returns an object; if you expect multiple,
              // adjust to your server response format. Here we push url if present.
              this.moreloading = false;
              if (Array.isArray(result)) {
                for (var i = 0, len = result.length; i < len; ++i) {
                  var fn = result[i].url || result[i].secure_url;
                  if (fn) this.images.push(fn);
                }
              } else {
                var fn = result.url || result.secure_url;
                if (fn) this.images.push(fn);
              }
            })
            .catch((error) => {
              console.log("error", error);
              this.moreloading = false;
            });
        }
      },
      openModal() {
        Swal.fire({
          title: "Enter Cake Cost",
          input: "text",
          inputPlaceholder: "Enter cake cost",
          confirmButtonText: "Add",
          confirmButtonColor: "#FF5A60",
          inputAttributes: {
            maxlength: 10,
            autocapitalize: "off",
            autocorrect: "off",
          },
        }).then((result) => {
          if (result.value) {
            this.costVisible = true;
            this.sizes.cost = result.value;
            this.cakesizeList.push({
              productId: this.sizes.productId,
              cost: this.sizes.cost,
              size: this.sizes.size,
            });
          }
        });
      },

      checkTitle() {
        var elem = this.$refs["title"];
        return (elem && (elem.state = this.myObj.title.length > 2 ? true : false));
      },
      checkCategory() {
        console.log("Osama");
      },
      checkDesc() {
        var elem = this.$refs["description"];
        if (elem) elem.state = this.myObj.description.length > 2 ? true : false;
      },
      checkCostperlayer() {
        var elem = this.$refs["Costperlayer"];
        if (this.myObj.perLayerCost <= 0) {
          if (elem) elem.state = false;
        } else {
          if (elem) elem.state = true;
        }
      },
      checkFlavour() {
        var elem = this.$refs["flavour"];
        if (this.flvObj !== null) {
          if (elem) elem.state = false;
        } else {
          if (elem) elem.state = true;
        }
      },
      deleteCover() {
        this.myObj.coverImg = "";
        this.loading = false;
      },
      getImageUrl() {
        return this.myObj.coverImg;
      },
      selectFile() {
        this.loading = true;
        this.file = this.$refs.file2 && this.$refs.file2.files ? this.$refs.file2.files[0] : null;
        if (this.file) {
          let formData = new FormData();
          formData.append("file", this.file);
          formData.append("upload_preset", "geotalent");
          axios
            .post("https://api.cloudinary.com/v1_1/dr9m7dwjw/upload", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((e) => {
              var fn = e.data.url;
              this.myObj.coverImg = fn;
              this.loading = "loaded";
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        }
      },

      AddProduct() {
        this.checkTitle();
        this.checkDesc();
        this.checkCostperlayer();
        if (
          this.checkTitle() == false ||
          this.checkDesc() == false ||
          this.checkCostperlayer()
        ) {
          this.$notify({
            group: "foo",
            type: "error ",
            text: "Please fill the form <b> Correctly ! </b>",
          });
        } else {
          if (
            this.myObj.productId === 0 &&
            this.myObj.vendorId === this.userVendorId &&
            this.myObj.vendorId !== 0
          ) {
            this.addOptions = "Saving...";
            var config = {
              method: "post",
              url: "https://waqta.appick.io/api/products/PostProduct",
              headers: {
                Authorization:
                  "Bearer " + (this.$store.state.userData.token || ""),
                "Content-Type": "application/json",
              },
              data: this.myObj,
            };

            axios(config).then((response) => {
              if (response.data.status == "success") {
                this.productResponse = response.data;
                this.flvObj.pId = this.productResponse.Id;
                this.sizes.productId = this.productResponse.Id;
                // keep original addItem call if exists
                if (this.addItem) this.addItem(this.productResponse.Id);
                this.proImg.pId = this.productResponse.Id;
                if (this.flvObj !== null) {
                  var configflv = {
                    method: "post",
                    url:
                      "https://okaaik.fastech.pk/api/cakeFlavours/AddcakeFlavours",
                    headers: {
                      Authorization:
                        "Bearer " + (this.$store.state.userData.token || ""),
                      "Content-Type": "application/json",
                    },
                    data: this.flvObj,
                  };
                  axios(configflv).then((response) => {
                    if (response.data.status == "success") {
                      var configsize = {
                        method: "post",
                        url:
                          "https://okaaik.fastech.pk/api/cakeSizes/PostsizesList/",
                        headers: {
                          Authorization:
                            "Bearer " + (this.$store.state.userData.token || ""),
                          "Content-Type": "application/json",
                        },
                        data: this.originalSizearr,
                      };

                      axios(configsize).then((response) => {
                        if (response.data.status == "success") {
                          var configimges = {
                            method: "post",
                            url:
                              "https://okaaik.fastech.pk/api/products/AddProductsImage/",
                            headers: {
                              Authorization:
                                "Bearer " + (this.$store.state.userData.token || ""),
                              "Content-Type": "application/json",
                            },
                            data: this.proImg,
                          };
                          axios(configimges).then((response) => {
                            if (response.data.status == "success") {
                              this.addOptions = "Add Cake";
                              this.$router.push("/apps/products/list");
                              this.$notify({
                                group: "foo",
                                type: "success ",
                                text: "cake added <b> sucess ! </b>",
                              }).then((res) => {});
                            }
                          });
                        }
                      });
                    }
                  });
                }
              }
            }).catch(err => {
              console.log('AddProduct error', err);
              this.addOptions = "Add Cake";
            });
          }
        }
      },

      // ----- LoadData updated to call new profile API and merge userData -----
      LoadData(id) {
        var profileUrl =
          "https://geotalent-backend-production.up.railway.app/api/UserProfile/LoadProfile?profileID=" + id;

        this.dataloading = true;

        axios
          .get(profileUrl, {
            headers: { Authorization: "Bearer " + (this.$store.state.userData.token || "") },
          })
          .then((res) => {
            const data = res.data.data || {};
            const profile = data.profile || {};
            const userData = data.userData || {};
                    console.log("userData:", userData); // check karlo id aa rahi hai ya nahi

            
            this.myObj = {
              ...this.myObj,
              id: id,
              // Profile fields
              pic: profile.pic || "",
              cove: profile.cover || "",
              title: profile.title || "",
              dob: profile.dob || "",
              age: profile.age || "",
              qualification: profile.qualification || "",
              height: profile.height || "",
              weight: profile.weight || "",
              bio: profile.bio || "",
              // UserData fields
              name: userData.name || "",
              email: userData.email || "",
              phone: userData.phone || "",
              address: userData.address || "",
              role: userData.role || "",
              status: userData.status || "",
            };

            this.dataloading = false;
           if (userData.id) {
      this.LoadRewards(userData.id);
    }
  })
          .catch((err) => {
            console.log("Profile API error:", err);
            this.dataloading = false;
            Swal.fire("Error!", "Failed to load user details.", "error");
          });
      },

      // --- New: Load Rewards for Geo Vault ---
      LoadRewards(profileId) {
        // Ensure profileId exists
        if (!profileId) {
          this.rewards = [];
          this.achievements = [];
          return;
        }

        const url = `https://geotalent-backend-production.up.railway.app/api/TalentAchievements/LoadDataUser?profileID=${profileId}`;
  console.log("API URL:", url);

        

        axios
          .get(url, {
            headers: { Authorization: "Bearer " + (this.$store.state.userData.token || "") },
          })
          .then((res) => {
            if (res.data && res.data.status === "success") {
              this.rewards = res.data.rewards || [];
              this.achievements = res.data.achievements || [];
            } else {
              this.rewards = [];
              this.achievements = [];
            }
          })
          .catch((err) => {
            console.log("Geo Vault API error:", err);
            this.rewards = [];
            this.achievements = [];
          });
      },

      /**
      * onAchievementClick
      * - Accepts either achievement object or id
      * - If the object already contains description/details, uses it
      * - Otherwise attempts to fetch single-achievement detail from server (safe fallback)
      */
      async onAchievementClick(achievementOrId) {
        let id = null;
        let achObj = null;

        if (typeof achievementOrId === "object") {
          achObj = achievementOrId;
          id = achievementOrId.id;
        } else {
          id = achievementOrId;
          achObj = this.achievements.find(a => a.id === id) || null;
        }

        // open modal immediately for snappier UX; show loader while detailed fetch proceeds
        this.showAchievementModal = true;
        this.modalLoading = true;
        this.selectedAchievement = null;

        // if the local object has enough fields (e.g., description) use it directly
        const hasDescription = achObj && (achObj.description || achObj.detail || achObj.longDescription || achObj.fullDescription);

        if (achObj && hasDescription) {
          // merge and show
          this.selectedAchievement = {
            ...achObj,
            description: achObj.description || achObj.detail || achObj.longDescription || achObj.fullDescription || ""
          };
          this.modalLoading = false;
          return;
        }

        // Otherwise attempt to fetch single achievement detail from API
        // NOTE: endpoint below is a best-effort guess; backend may differ.
        // If your backend provides a known single-item endpoint, replace accordingly.
        try {
          // Try a few plausible endpoints in order (silently ignore 404/404-like errors)
          const candidateEndpoints = [
            `https://geotalent-backend-production.up.railway.app/api/TalentAchievements/Get?achievementID=${id}`,
            `https://geotalent-backend-production.up.railway.app/api/TalentAchievements/LoadById?achievementID=${id}`,
            `https://geotalent-backend-production.up.railway.app/api/TalentAchievements/Load?achievementID=${id}`,
            // fallback generic
            `https://geotalent-backend-production.up.railway.app/api/TalentAchievements/LoadData?achievementID=${id}`
          ];

          let detail = null;
          for (let ep of candidateEndpoints) {
            try {
              const res = await axios.get(ep, {
                headers: { Authorization: "Bearer " + (this.$store.state.userData.token || "") },
              });
              if (res && res.data) {
                // Accept various shapes: { status:'success', data: {...} } or direct object
                if (res.data.status === "success" && res.data.data) {
                  detail = res.data.data;
                  break;
                } else if (res.data.data) {
                  detail = res.data.data;
                  break;
                } else if (res.data.title || res.data.description) {
                  // API returned the object directly
                  detail = res.data;
                  break;
                }
              }
            } catch (e) {
              // ignore this endpoint and try next
              // console.debug('endpoint failed', ep, e);
            }
          }

          if (detail) {
            // merge with existing minimal achObj fields so we can show all info
            this.selectedAchievement = {
              ...achObj,
              ...detail,
              description: detail.description || detail.detail || detail.longDescription || detail.fullDescription || (achObj ? (achObj.description || "") : "")
            };
          } else {
            // nothing found: show the local achObj if available, else a placeholder
            this.selectedAchievement = achObj ? { ...achObj, description: achObj.description || "" } : { title: "Details unavailable", description: "No further details found for this achievement." };
          }
        } catch (err) {
          console.error("Error fetching achievement detail:", err);
          // fallback
          this.selectedAchievement = achObj ? { ...achObj, description: achObj.description || "" } : { title: "Details unavailable", description: "No further details found for this achievement." };
        } finally {
          this.modalLoading = false;
        }
      },

      closeAchievementModal() {
        this.showAchievementModal = false;
        this.selectedAchievement = null;
        this.modalLoading = false;
      },

      // helper: formatted description (sanitized minimal HTML allowed)
      // using v-html in template; ensure backend content is trusted or sanitize on server.
      formattedText(raw) {
        if (!raw) return "";
        // minimal handling: preserve line breaks
        return (raw + "").replace(/\n/g, "<br/>");
      },

      // other helper methods can go here if needed
    },

    computed: {
      modalTitle() {
        return this.selectedAchievement ? (this.selectedAchievement.title || "Achievement") : "Achievement";
      },
      modalSubtitle() {
        if (!this.selectedAchievement) return "";
        // show a small subtitle if available (e.g., date or source)
        return this.selectedAchievement.subtitle || this.selectedAchievement.category || this.selectedAchievement.where || "";
      },
      formattedDescription() {
        return this.formattedText(this.selectedAchievement ? (this.selectedAchievement.description || this.selectedAchievement.detail || "") : "");
      },
      hasExtraFields() {
        if (!this.selectedAchievement) return false;
        // show some extra fields only if present (avoid noisy listing)
        const keys = Object.keys(this.selectedAchievement).filter(k => !["id","title","description","mediaURL","image","shortDescription","detail","longDescription","fullDescription"].includes(k));
        return keys.length > 0;
      },
      extraFieldsToShow() {
        if (!this.selectedAchievement) return {};
        const obj = {};
        const keys = Object.keys(this.selectedAchievement).filter(k => !["id","title","description","mediaURL","image","shortDescription","detail","longDescription","fullDescription"].includes(k));
        keys.forEach(k => {
          // only show simple values
          if (["string","number","boolean"].includes(typeof this.selectedAchievement[k])) {
            obj[k] = this.selectedAchievement[k];
          }
        });
        return obj;
      }
    },

    mounted() {
      // nothing extra required here; created() already calls LoadData+LoadRewards
      const userID = this.$route.query.userID;
  console.log("User ID:", userID);

 
    },

    beforeDestroy() {
      // cleanup if needed
    },
  };
  </script>
